import { useEffect } from 'react';

/**
 * Хук для подключения Яндекс.Метрики
 */
export const useYandexMetrika = () => {
  useEffect(() => {
    // Проверяем, что окружение - production
    if (import.meta.env.VITE_SERVER_ENVIRONMENT === 'production') {
      // Создаем тег <script> с кодом Яндекс.Метрики
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        (function(m,e,t,r,i,k,a){
          m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {
            if (document.scripts[j].src === r) {
              return;
            }
          }
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a);
        })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(100577160, "init", {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true
        });
      `;

      // Создаем <noscript> с изображением
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `
        <div>
          <img src="https://mc.yandex.ru/watch/100577160" style="position:absolute; left:-9999px;" alt="" />
        </div>
      `;

      // Добавляем теги в <head>
      document.head.appendChild(script);
      document.head.appendChild(noscript);

      // Очистка: удаляем теги при размонтировании компонента
      return () => {
        document.head.removeChild(script);
        document.head.removeChild(noscript);
      };
    }
  }, []);
};
